var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jd-section jd-section--duty"},[_c('p',{staticClass:"job-section__header"},[_vm._v(_vm._s(_vm.$t('jobDetail.jobDuty')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.jobDescription || _vm.$t('general.notAvailable')))])])}
var staticRenderFns = []

export { render, staticRenderFns }